import React, { ReactNode } from "react";
import { IntlProvider as Provider } from "react-intl";

import { defaultLocale, locales } from "src/i18n";
import { currentLocale } from "src/i18n/hosts";

type Props = {
  children: ReactNode;
};

// Язык версии определяется ДОМЕНОМ (см. src/i18n/hosts.ts), а не языком браузера.
document.documentElement.lang = currentLocale;

export const IntlProvider: React.FC<Props> = ({ children }) => (
  <Provider
    defaultLocale={defaultLocale}
    key={currentLocale}
    locale={currentLocale}
    messages={locales[currentLocale].dictionary}
    textComponent={React.Fragment}
  >
    {children}
  </Provider>
);
